module.exports = __webpack_public_path__ + "static/img/keco-vinyl.96f73b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/keco-vinyl.jpg
// module id = kDXx
// module chunks = 0